// src/data/trainers/AdvancedBodyweightTrainers.js

// Marcus Blackwood's workout programs
const marcusBlackwoodPrograms = [
    {
        id: 'calisthenics-master',
        name: 'Calisthenics Master',
        description: 'Advanced calisthenics plan focusing on extraordinary strength-to-weight ratio through progressive movement patterns',
        pattern: 'geihmj', // legs, chest, biceps, shoulders, arms, hips
        reps: 8,
        sets: 4,
        focus: 'Movement Foundation'
    },
    {
        id: 'advanced-strength',
        name: 'Advanced Strength',
        description: 'Exceptional strength in all major movement patterns through strategic exercise selection and progressive overload',
        pattern: 'gehk!', // legs, chest, shoulders, back, overall
        reps: 6,
        sets: 5,
        focus: 'Strength Development'
    },
    {
        id: 'explosive-movement',
        name: 'Explosive Movement',
        description: 'Rate of force development and reactive strength through explosive bodyweight training with contrast principles',
        pattern: 'ggaa!', // legs, legs, abs, abs, overall
        reps: 6,
        sets: 4,
        focus: 'Explosive Power'
    },
    {
        id: 'gymnastic-skills',
        name: 'Gymnastic Skills',
        description: 'Movement quality, coordination, and spatial awareness through gymnastics-inspired bodyweight exercises',
        pattern: 'ekhma', // chest, back, shoulders, arms, abs
        reps: 6,
        sets: 4,
        focus: 'Gymnastic Control'
    },
    {
        id: 'isometric-power',
        name: 'Isometric Power',
        description: 'Maximal strength through static holds at different joint angles with progressive duration challenges',
        pattern: 'gehkm', // legs, chest, shoulders, back, arms
        reps: 10,
        sets: 3,
        focus: 'Isometric Strength'
    },
    {
        id: 'body-control',
        name: 'Body Control',
        description: 'Complete mastery over body positioning through combined strength and mobility work with movement flows',
        pattern: 'gehka!', // legs, chest, shoulders, back, abs, overall
        reps: 8,
        sets: 3,
        focus: 'Movement Integration'
    }
];

// Dante Rivera's workout programs
const danteRiveraPrograms = [
    {
        id: 'planche-training',
        name: 'Planche Training',
        description: 'Specialized strength, body positioning, and balance necessary for planche progressions with anterior deltoid focus',
        pattern: 'ehgamj', // chest, shoulders, legs, abs, arms, hips
        reps: 8,
        sets: 3,
        focus: 'Planche Mastery'
    },
    {
        id: 'handstand-mastery',
        name: 'Handstand Mastery',
        description: 'Equal parts strength, balance, and proprioception for comprehensive handstand capabilities',
        pattern: 'hhfae!', // shoulders, shoulders, forearms, abs, chest, overall
        reps: 8,
        sets: 3,
        focus: 'Handstand Skills'
    },
    {
        id: 'front-lever',
        name: 'Front Lever',
        description: 'Exceptional back, core, and lat strength necessary for front lever progressions with body tension',
        pattern: 'kkapa!', // back, back, abs, traps, abs, overall
        reps: 8,
        sets: 3,
        focus: 'Front Lever Power'
    },
    {
        id: 'advanced-rings',
        name: 'Advanced Rings',
        description: 'Extraordinary stabilization strength and body control for advanced ring elements with progressive instability',
        pattern: 'ehtifm', // chest, shoulders, triceps, biceps, forearms, arms
        reps: 8,
        sets: 3,
        focus: 'Ring Mastery'
    },
    {
        id: 'muscle-up-program',
        name: 'Muscle-Up Program',
        description: 'Precise combination of pulling and pushing strength for smooth muscle-up execution and transition mastery',
        pattern: 'kkie!', // back, back, biceps, chest, overall
        reps: 8,
        sets: 4,
        focus: 'Muscle-Up Skills'
    },
    {
        id: 'human-flag',
        name: 'Human Flag',
        description: 'Exceptional lateral core strength and shoulder stability for human flag progressions with oblique focus',
        pattern: 'zaap!', // obliques, abs, abs, traps, overall
        reps: 8,
        sets: 3,
        focus: 'Human Flag Power'
    }
];

// Ethan Harris's workout programs
const ethanHarrisPrograms = [
    {
        id: 'golden-power',
        name: 'Golden Power',
        description: 'Maximal strength and power through compound movements targeting fast-twitch muscle fibers and neural recruitment',
        pattern: 'ehgamj', // chest, shoulders, legs, abs, arms, hips
        reps: 8,
        sets: 3,
        focus: 'Power Development'
    },
    {
        id: 'explosive-strength',
        name: 'Explosive Strength',
        description: 'Maximal force production and rate of force development for explosive movement patterns and motor unit recruitment',
        pattern: 'hhfea!', // shoulders, shoulders, forearms, chest, abs, overall
        reps: 8,
        sets: 3,
        focus: 'Explosive Power'
    },
    {
        id: 'ultimate-endurance',
        name: 'Ultimate Endurance',
        description: 'Work capacity, lactate threshold, and cardiovascular efficiency through conditioning protocols and density training',
        pattern: 'kakpa!', // back, abs, back, traps, abs, overall
        reps: 8,
        sets: 3,
        focus: 'Ultimate Conditioning'
    },
    {
        id: 'beast-mode-workout',
        name: 'Beast Mode Workout',
        description: 'Savage intensity and mental toughness through high-volume, high-effort training with progressive density',
        pattern: 'hetifm', // shoulders, chest, triceps, biceps, forearms, arms
        reps: 8,
        sets: 3,
        focus: 'Beast Mode Intensity'
    },
    {
        id: 'elite-transformation',
        name: 'Elite Transformation',
        description: 'Optimal muscle hypertrophy, fat metabolism, and structural balance for dramatic physical transformation',
        pattern: 'kike!', // back, biceps, back, chest, overall
        reps: 8,
        sets: 4,
        focus: 'Body Transformation'
    },
    {
        id: 'peak-performance',
        name: 'Peak Performance',
        description: 'Integration of strength, power, endurance, and mobility for elite physical performance and athletic metrics',
        pattern: 'azap!', // abs, obliques, abs, traps, overall
        reps: 8,
        sets: 3,
        focus: 'Peak Athletics'
    }
];

// Victor Stone's workout programs
const victorStonePrograms = [
    {
        id: 'stone-strength',
        name: 'Stone Strength',
        description: 'Foundational strength through primal movement patterns and progressive loading protocols targeting multiple muscle groups',
        pattern: 'ehgamj', // chest, shoulders, legs, abs, arms, hips
        reps: 8,
        sets: 3,
        focus: 'Strength Foundation'
    },
    {
        id: 'bulletproof-body',
        name: 'Bulletproof Body',
        description: 'Joint stability, tissue quality, and movement competency for injury prevention and physical durability',
        pattern: 'hhfae!', // shoulders, shoulders, forearms, abs, chest, overall
        reps: 8,
        sets: 3,
        focus: 'Body Resilience'
    },
    {
        id: 'heavy-hitter',
        name: 'Heavy Hitter',
        description: 'Rotational strength, hip drive, and core stability for devastating striking power and full-body coordination',
        pattern: 'kkapa!', // back, back, abs, traps, abs, overall
        reps: 8,
        sets: 3,
        focus: 'Striking Power'
    },
    {
        id: 'combat-conditioning',
        name: 'Combat Conditioning',
        description: 'Metabolic conditioning and recovery capabilities for sustained high-intensity effort and tactical endurance',
        pattern: 'ehtifm', // chest, shoulders, triceps, biceps, forearms, arms
        reps: 8,
        sets: 3,
        focus: 'Combat Endurance'
    },
    {
        id: 'elite-athletics',
        name: 'Elite Athletics',
        description: 'Optimal integration of strength, power, and movement efficiency for high-level athletic performance',
        pattern: 'kkie!', // back, back, biceps, chest, overall
        reps: 8,
        sets: 4,
        focus: 'Athletic Excellence'
    },
    {
        id: 'warrior-training',
        name: 'Warrior Training',
        description: 'Physical and mental resilience through integrated challenges targeting strength, endurance, and tactical capability',
        pattern: 'zaap!', // obliques, abs, abs, traps, overall
        reps: 8,
        sets: 3,
        focus: 'Warrior Preparation'
    }
];

// Logan Reeves's workout programs
const loganReevesPrograms = [
    {
        id: 'advanced-movement',
        name: 'Advanced Movement',
        description: 'Movement quality, joint centration, and neuromuscular efficiency through progressive movement patterns',
        pattern: 'ehgamj', // chest, shoulders, legs, abs, arms, hips
        reps: 8,
        sets: 3,
        focus: 'Movement Excellence'
    },
    {
        id: 'skill-progression',
        name: 'Skill Progression',
        description: 'Motor patterns, body awareness, and neuromuscular control for skill mastery through systematic progression',
        pattern: 'hhfae!', // shoulders, shoulders, forearms, abs, chest, overall
        reps: 8,
        sets: 3,
        focus: 'Skill Development'
    },
    {
        id: 'functional-power',
        name: 'Functional Power',
        description: 'Kinetic chain coordination, rate of force development, and movement efficiency for authentic functional power',
        pattern: 'kkapa!', // back, back, abs, traps, abs, overall
        reps: 8,
        sets: 3,
        focus: 'Power Optimization'
    },
    {
        id: 'balance-mastery',
        name: 'Balance Mastery',
        description: 'Sensory awareness, vestibular conditioning, and dynamic stability for advanced balance capabilities',
        pattern: 'ehtifm', // chest, shoulders, triceps, biceps, forearms, arms
        reps: 8,
        sets: 3,
        focus: 'Balance Control'
    },
    {
        id: 'core-integration',
        name: 'Core Integration',
        description: 'Core sequencing, rotational power, and anti-movement capabilities for total core mastery',
        pattern: 'kkie!', // back, back, biceps, chest, overall
        reps: 8,
        sets: 4,
        focus: 'Core Mastery'
    },
    {
        id: 'flow-training',
        name: 'Flow Training',
        description: 'Integrated movement skills, transitional strength, and mental focus for seamless movement flow',
        pattern: 'zaap!', // obliques, abs, abs, traps, overall
        reps: 8,
        sets: 3,
        focus: 'Movement Flow'
    }
];

// Derek Cruz's workout programs
const derekCruzPrograms = [
    {
        id: 'iron-body',
        name: 'Iron Body',
        description: 'Structural strength, connective tissue durability, and muscular density through unconventional loading patterns',
        pattern: 'ehmakf', // chest, shoulders, arms, abs, back, forearms
        reps: 8,
        sets: 3,
        focus: 'Structural Strength'
    },
    {
        id: 'gravity-defier',
        name: 'Gravity Defier',
        description: 'Body control, strength-to-weight ratio, and spatial awareness for gravity-defying movements',
        pattern: 'hafket!', // shoulders, abs, forearms, back, chest, triceps, overall
        reps: 8,
        sets: 3,
        focus: 'Bodyweight Mastery'
    },
    {
        id: 'street-workout',
        name: 'Street Workout',
        description: 'Pulling power, pushing strength, and body control for impressive street calisthenics',
        pattern: 'bkifa!', // back, back, biceps, forearms, abs, overall
        reps: 8,
        sets: 3,
        focus: 'Street Skills'
    },
    {
        id: 'elite-calisthenics',
        name: 'Elite Calisthenics',
        description: 'Strength-to-weight ratio, motor control, and movement patterns for advanced bodyweight skills',
        pattern: 'ethfkm', // chest, triceps, shoulders, forearms, back, arms
        reps: 8,
        sets: 3,
        focus: 'Calisthenics Elite'
    },
    {
        id: 'extreme-conditioning',
        name: 'Extreme Conditioning',
        description: 'Work capacity, lactate tolerance, and mental toughness through high-intensity conditioning protocols',
        pattern: 'kbiae!', // back, biceps, abs, chest, overall
        reps: 8,
        sets: 4,
        focus: 'Extreme Conditioning'
    },
    {
        id: 'strength-evolution',
        name: 'Strength Evolution',
        description: 'Comprehensive strength approach integrating absolute strength, strength-speed, and strength endurance',
        pattern: 'zafikm!', // obliques, abs, forearms, biceps, back, arms, overall
        reps: 8,
        sets: 3,
        focus: 'Strength Mastery'
    }
];

// All advanced bodyweight trainers data
export const advancedBodyweightTrainers = {
    'marcus-blackwood': {
        id: 'marcus-blackwood',
        name: 'Marcus Blackwood',
        specialization: 'Calisthenics & Gymnastics Specialist',
        image: '/assets/images/v28.jpg',
        experience: '15 years',
        category: 'advanced-bodyweight',
        intro: `Marcus Blackwood forged his impressive physique and expertise through years of elite gymnastics competition and advanced bodyweight training. With his powerful build, full beard, and intense focus, Marcus specializes in advanced calisthenics and bodyweight mastery that pushes the boundaries of human potential. After leaving competitive gymnastics, he developed his signature training methodology that emphasizes perfect form, progressive overload, and mastery of advanced movement patterns. "Strength isn't built overnight, but through consistent, intelligent progression," is his mantra when teaching his challenging techniques. Marcus combines cutting-edge exercise science with traditional bodyweight disciplines to help clients achieve extraordinary levels of strength, control, and body awareness rarely seen in conventional training approaches.`,
        programs: marcusBlackwoodPrograms
    },
    'dante-rivera': {
        id: 'dante-rivera',
        name: 'Dante Rivera',
        specialization: 'Advanced Calisthenics & Skills Specialist',
        image: '/assets/images/v46.jpg',
        experience: '12 years',
        category: 'advanced-bodyweight',
        intro: `Dante Rivera developed his extraordinary skills and physique through years as a professional circus performer and later as an elite calisthenics competitor. With his lean, muscular build, distinctive facial hair, and intense focus, Dante specializes in advanced bodyweight skills that blend strength, balance, and body control. After retiring from the international competition circuit, he refined his teaching methodology to make advanced skills accessible through systematic progression. "True mastery comes from perfect practice, not just blind repetition," is his guiding principle when coaching. Dante's unique background combines elements from gymnastics, martial arts, and circus arts to create training programs that develop not just impressive physiques but extraordinary movement capabilities rarely seen in conventional fitness.`,
        programs: danteRiveraPrograms
    },
    'ethan-harris': {
        id: 'ethan-harris',
        name: 'Ethan "Gold" Harris',
        specialization: 'Bodybuilding & Power Specialist',
        image: '/assets/images/v62.jpg',
        experience: '14 years',
        category: 'advanced-bodyweight',
        intro: `Ethan "Gold" Harris earned his nickname through his golden-era inspired physique development methodology and signature blonde hair. With his imposing muscular build, intense gaze, and commanding presence, Ethan specializes in transformational body recomposition programs that blend old-school principles with cutting-edge science. After winning multiple natural bodybuilding championships, he developed his system to make dramatic physical transformations accessible to everyday athletes. "The body adapts to exactly what you demand of it—nothing more, nothing less," is his core training philosophy. Ethan's unique approach combines traditional bodybuilding, strength athletics, and metabolic conditioning to develop physiques that are as functional as they are impressive.`,
        programs: ethanHarrisPrograms
    },
    'victor-stone': {
        id: 'victor-stone',
        name: 'Victor Stone',
        specialization: 'Tactical Strength & Combat Specialist',
        image: '/assets/images/v78.jpg',
        experience: '16 years',
        category: 'advanced-bodyweight',
        intro: `Victor Stone transformed his body through military special operations training and later as a tactical strength coach. With his powerful build, intense gaze, and commanding presence, Victor specializes in functional strength training that combines raw power with tactical precision. After serving in elite military units, he developed training systems that prepare individuals for extreme physical demands in any environment. "Strength that cannot be applied is just for show," is his core training philosophy. Victor's background blending military conditioning, combat sports, and strength athletics creates uniquely effective programs that develop extraordinary resilience alongside impressive physical capabilities.`,
        programs: victorStonePrograms
    },
    'logan-reeves': {
        id: 'logan-reeves',
        name: 'Logan Reeves',
        specialization: 'Movement Optimization & Biomechanics Specialist',
        image: '/assets/images/v80.jpg',
        experience: '13 years',
        category: 'advanced-bodyweight',
        intro: `Logan Reeves discovered his passion for movement optimization through his background in competitive martial arts and physical therapy. With his lean, defined physique, analytical gaze, and methodical approach, Logan specializes in movement-based training that emphasizes biomechanical efficiency and progressive skill development. After recovering from a catastrophic injury through his own rehabilitation methods, he developed systematic approaches to movement mastery. "Quality movement is the foundation of all physical achievement," is his training philosophy. Logan's unique background blending martial arts, physical therapy, and strength training creates uniquely effective programs that develop exceptional movement patterns alongside impressive physical capabilities.`,
        programs: loganReevesPrograms
    },
    'derek-cruz': {
        id: 'derek-cruz',
        name: 'Derek "Iron" Cruz',
        specialization: 'Raw Functional Strength & Street Calisthenics Specialist',
        image: '/assets/images/v86.jpg',
        experience: '14 years',
        category: 'advanced-bodyweight',
        intro: `Derek "Iron" Cruz forged his physique through years of underground strength training and street calisthenics. With his densely muscular build, intense stare, and rugged appearance, Derek specializes in raw functional strength that transfers directly to real-world performance. After dominating the underground strength scene, he developed unique training methodologies that build exceptional strength without conventional equipment. "True strength isn't measured on a platform, but in life's most demanding moments," is his training philosophy. Derek's unconventional background combining street workouts, industrial labor, and combat sports creates distinctively effective programs that develop extraordinary strength alongside impressive physical resilience.`,
        programs: derekCruzPrograms
    }
};

export default advancedBodyweightTrainers;